<dashboard-dialog-frame class="specialist-sign-up-note-editor-dialog" [header]="'Edit Sign-up'" [actions]="[]" icon="fa-pencil" [dialogRef]="dialogRef">

	<div class="d-flex flex-column justify-content-between p-2 h-100">
		<div class="d-flex flex-column gap-2">
			<common-text-field [field]="note()"></common-text-field>
		</div>

		<div>
			<common-button-row [center]="true">
				<button #formSaveBtn class="btn btn-primary">Save</button>
				<button class="btn btn-standard" (click)="revertValues()">Revert</button>
				<button class="btn btn-standard" (click)="dialogRef.close()">Close</button>
			</common-button-row>
		</div>
	</div>

</dashboard-dialog-frame>